import AbstractProduction from '@/roc/effects/Production/AbstractProduction';
import EffectMechanic from '@/roc/effects/EffectMechanic';
class TriggeredProduction extends AbstractProduction {
    __amount;
    __condition;
    constructor(amount, condition, duration, output) {
        super(EffectMechanic.TRIGGERED_PRODUCTION, duration, output);
        this.__amount = amount;
        this.__condition = condition;
    }
    clone(amount = null, condition = null, duration = null, output = null) {
        return new TriggeredProduction(amount || this.__amount, condition || this.__condition, duration || this.__duration, output || this.__output);
    }
    formatDescription(level, era) {
        const dur = this.__duration.format(level, era);
        const isAn = dur.startsWith('a') || dur.startsWith('e') || dur.startsWith('i') || dur.startsWith('o') || dur.startsWith('u');
        let am = this.__amount.calculate(level, era);
        am = this.applyMods(am);
        const r = [
            'Gain',
            'a',
            this.__output.toString(),
            'when',
            'a',
            this.__condition.toString(),
            'up',
            'to',
            am,
            'time' + (am > 1 ? 's' : ''),
            isAn ? 'an' : 'a',
            dur === '1d' ? 'day' : dur,
        ];
        return r.join(' ');
    }
}
export default TriggeredProduction;
